import axios from 'axios'
import {UserModel} from './_models'
import { getBaseURL } from '../../../helper-functions/api-header-config';
import secureLocalStorage from 'react-secure-storage';
const API_URL = process.env.REACT_APP_API_URL
const LOGIN_API_URL = process.env.REACT_APP_API_URL_CENTRAL
let current_url = window.location.href;
getBaseURL(current_url);
export const GET_USER_BY_ACCESSTOKEN_URL = `${secureLocalStorage.getItem("baseURL")}/api/verify-token`
export const LOGIN_URL = `${LOGIN_API_URL}/api/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${LOGIN_API_URL}/api/forget-password`
// all permissions of logged in user
export const get_user_permissions = async () => {
  let response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/user-permissions`);
  return response.data;
}
// Server should return AuthModel
export async function login(email: string, password: string) {
  const response = await axios.post(LOGIN_URL, {
    email,
    password,
  })
  return response?.data
};
// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}
// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}
export function getUserByToken(token: string) {
  const authValue = localStorage.getItem('kt-auth-react-v');
  if (authValue) {
    return axios.post<UserModel>(
      `${secureLocalStorage.getItem("baseURL")}/api/verify-token`, 
      { access_token: token }
    ).then(response => {
      console.log(response)
      localStorage.setItem('profile_completed', ((response.data.data as any).profile_completed)?.toString() || '');
      localStorage.setItem('auth_user_id', ((response.data.data as any).Auth_user_id)?.toString() || '');
      localStorage.setItem('is_superadmin', ((response.data.data as any).is_superadmin)?.toString() || '');
      return response;
    });
  } else {
    console.warn("No valid auth key found in localStorage.");
    return Promise.reject("Authorization key not found.");
  }
}
export async function getOrganisationMedia() {
  let baseURL:any= secureLocalStorage.getItem("baseURL");
  // Wait for baseURL if not set
  if (!baseURL) {
    console.warn("baseURL not set yet. Waiting...");
    baseURL = await waitForBaseURL();
  }
  return axios.get(`${baseURL}/api/get-logos-images`);
}
function waitForBaseURL() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const url = secureLocalStorage.getItem("baseURL");
      if (url) {
        clearInterval(interval);
        resolve(url);
      }
    }, 100); // Check every 100ms
  });
}
// Sign Out
export function signout(access_token: string) {
  const headers = {
    Authorization: `Bearer ${access_token}`,
  };
    return axios.post(`${secureLocalStorage.getItem("baseURL")}/api/logout`, {}, { headers });
}